import React, { useState, useEffect } from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import styles from './index.module.scss';

const ContactsAdressBlock = ({ blockData, path_to_folder, blockIndex }) => {
  // Координаты по умолчанию
  const DEFAULT_COORDINATES = [55.816318, 37.571058];

  const [mapLoaded, setMapLoaded] = useState(false);
  const [geocodedCoords, setGeocodedCoords] = useState(null);
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [ymaps, setYmaps] = useState(null);

  // Получаем координаты для карты - проверяем разные варианты написания
  const coordinatesContent = blockData?.block_content?.find(
    (content) =>
      (content.cotent_type === 'text' || content.content_type === 'text') &&
      (content.cotent_tag === 'coordinates' ||
        content.content_tag === 'coordinates' ||
        content.cotent_tag === 'coordinats' ||
        content.content_tag === 'coordinats') &&
      content.content_text &&
      content.content_text !== 'none',
  );

  // Получаем адрес для геокодирования
  const addressContent = blockData?.block_content?.find(
    (content) =>
      (content.cotent_type === 'text' || content.content_type === 'text') &&
      (content.cotent_tag === 'adress' || content.content_tag === 'address') &&
      content.content_text &&
      content.content_text !== 'none',
  );

  // Парсим координаты (формат: "широта,долгота" или "широта, долгота")
  let coordinates = null;
  if (coordinatesContent?.content_text) {
    const coordsArray = coordinatesContent.content_text
      .split(',')
      .map((coord) => parseFloat(coord.trim()));
    if (coordsArray.length === 2 && !isNaN(coordsArray[0]) && !isNaN(coordsArray[1])) {
      coordinates = coordsArray;
    }
  }

  // Геокодирование адреса через Яндекс.Карты API (работает без ключа)
  useEffect(() => {
    // Пробуем использовать ymaps из window, если из state нет
    const ymapsInstance = ymaps || window.ymaps;

    // Если координаты уже есть, нет адреса или нет ymaps, ничего не делаем
    if (coordinates) {
      return;
    }
    if (!addressContent?.content_text) {
      return;
    }
    if (!ymapsInstance) {
      return;
    }

    const geocodeAddress = async () => {
      setIsGeocoding(true);
      try {
        // Нормализуем адрес
        let normalizedAddress = addressContent.content_text.replace(/\s+/g, ' ').trim();

        // Добавляем "Россия" если не указана страна
        if (
          !normalizedAddress.toLowerCase().includes('россия') &&
          !normalizedAddress.toLowerCase().includes('russia')
        ) {
          normalizedAddress = 'Россия, ' + normalizedAddress;
        }

        // Используем ymaps.geocode вместо прямого API запроса
        const result = await ymapsInstance.geocode(normalizedAddress, { results: 5 });
        const geoObjects = result.geoObjects;

        if (geoObjects.getLength() > 0) {
          // Берем первый результат
          const firstGeoObject = geoObjects.get(0);
          const coords = firstGeoObject.geometry.getCoordinates();

          setGeocodedCoords(coords);
        }
      } catch (error) {
        // Ошибка геокодирования
      } finally {
        setIsGeocoding(false);
      }
    };

    geocodeAddress();
  }, [addressContent?.content_text, coordinates, ymaps]);

  // Дополнительный useEffect для проверки window.ymaps с задержкой
  useEffect(() => {
    if (ymaps || coordinates || !addressContent?.content_text) {
      return;
    }

    const checkYmaps = setInterval(() => {
      if (window.ymaps) {
        setYmaps(window.ymaps);
        clearInterval(checkYmaps);
      }
    }, 100);

    // Очистка через 10 секунд
    const timeout = setTimeout(() => {
      clearInterval(checkYmaps);
    }, 10000);

    return () => {
      clearInterval(checkYmaps);
      clearTimeout(timeout);
    };
  }, [ymaps, coordinates, addressContent?.content_text]);

  // Ранний возврат после всех хуков
  if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  // Определяем финальные координаты для отображения
  let finalCoordinates = coordinates || geocodedCoords;

  // Если координаты не найдены, используем координаты по умолчанию
  if (!finalCoordinates) {
    finalCoordinates = DEFAULT_COORDINATES;
  }

  // Фильтруем контент для отображения (все кроме coordinates)
  const displayContent = blockData.block_content.filter((content) => {
    // Исключаем координаты
    if (
      content.cotent_tag === 'coordinates' ||
      content.content_tag === 'coordinates' ||
      content.cotent_tag === 'coordinats' ||
      content.content_tag === 'coordinats'
    ) {
      return false;
    }

    // Исключаем пустой контент
    if (!content.content_text || content.content_text === 'none') {
      return false;
    }

    return true;
  });

  // Ранний выход если нет контента для отображения (но всегда показываем карту)
  // if (displayContent.length === 0 && !finalCoordinates) {
  //   return null;
  // }

  // Функция для рендеринга контента
  const renderContent = (content, index) => {
    if ((content.cotent_type === 'text' || content.content_type === 'text') && content.content_text && content.content_text !== 'none') {
      return (
        <p key={`content-${index}`} className={styles.contentText}>
          {content.content_text}
        </p>
      );
    }
    return null;
  };

  return (
    <YMaps
      query={{
        lang: 'ru_RU',
        load: 'package.full',
      }}
      onLoad={(ymapsInstance) => {
        setYmaps(ymapsInstance);
      }}
      onError={() => {
        // Ошибка загрузки YMaps
      }}>
      <div className={styles.contactsAdressBlock}>
        <div className={styles.addressContainer}>
          {/* Отображаем весь контент */}
          {displayContent.map((content, index) => renderContent(content, index))}

          {/* Яндекс Карта (если есть координаты) */}
          {finalCoordinates && finalCoordinates.length === 2 && (
            <div className={styles.mapContainer}>
              {/* Индикатор загрузки геокодирования */}
              {isGeocoding && (
                <div
                  style={{
                    backgroundColor: '#d1ecf1',
                    color: '#0c5460',
                    padding: '10px',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    textAlign: 'center',
                    fontSize: '14px',
                  }}>
                  🔍 Определяем координаты по адресу...
                </div>
              )}
              {/* Уведомление о типе координат */}
              {!coordinatesContent && !geocodedCoords && (
                <div
                  style={{
                    backgroundColor: '#d4edda',
                    color: '#155724',
                    padding: '10px',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    textAlign: 'center',
                    fontSize: '14px',
                  }}>
                  📍 Координаты: {DEFAULT_COORDINATES[0]}, {DEFAULT_COORDINATES[1]}
                </div>
              )}
              {geocodedCoords && (
                <div
                  style={{
                    backgroundColor: '#d4edda',
                    color: '#155724',
                    padding: '10px',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    textAlign: 'center',
                    fontSize: '14px',
                  }}>
                  ✓ Координаты определены по адресу: {addressContent?.content_text}
                </div>
              )}
              <Map
                defaultState={{
                  center: finalCoordinates,
                  zoom: 16,
                  controls: ['zoomControl', 'fullscreenControl'],
                }}
                width='100%'
                height={window.innerWidth <= 767 ? '250px' : '400px'}
                onLoad={() => {
                  setMapLoaded(true);
                }}
                onError={() => {
                  // Ошибка загрузки карты
                }}
                modules={['control.ZoomControl', 'control.FullscreenControl']}>
                <Placemark
                  geometry={finalCoordinates}
                  options={{
                    preset: 'islands#redIcon',
                  }}
                  properties={{
                    hintContent: 'Наш адрес',
                    balloonContent: 'Мы находимся здесь',
                  }}
                />
              </Map>
              {!mapLoaded && (
                <div style={{ textAlign: 'center', padding: '20px' }}>Загрузка карты...</div>
              )}
            </div>
          )}
          {finalCoordinates && finalCoordinates.length !== 2 && (
            <div style={{ color: 'red', padding: '10px', textAlign: 'center' }}>
              Ошибка: Некорректные координаты ({finalCoordinates.join(', ')})
            </div>
          )}
        </div>
      </div>
    </YMaps>
  );
};

export default ContactsAdressBlock;
